module.exports = __webpack_public_path__ + "img/背包恐龙公仔.d23261b5.jpg";